import {
  AgxBodyText,
  AgxColumn,
  AgxIconCircularGreenTick,
  BlankSalesContractStatus,
  CampaignDetailModel,
  Images,
} from '@urbanx/agx-ui-components';
import {
  AgxSpacer,
  AgxTypography,
  Icon_Clock,
} from '@urbanx/agx.ui-components2';
import React, { useMemo } from 'react';

interface SolicitorContractDetailsProps {
  campaign: CampaignDetailModel;
}

export const SolicitorContractDetails: React.FC<
  SolicitorContractDetailsProps
> = ({ campaign }) => {
  const bodyContent = useMemo(() => {
    if (!campaign.blankContractIsLive) {
      return (
        <>
          <Icon_Clock
            color="var(--fg-disabled, #DFDFDF)"
            width={44}
            height={44}
          />
          <AgxTypography
            id="await-contract-from-solicitor"
            type="body"
            size="medium"
          >
            Awaiting Contract from Solicitor
          </AgxTypography>
        </>
      );
    } else {
      if (campaign.blankSalesContractStatus) {
        return (
          <>
            <AgxIconCircularGreenTick width={44} height={45} />
            <AgxTypography
              id={`${campaign.blankSalesContractStatus}-contract-from-solicitor`}
              type="body"
              size="medium"
            >
              {campaign.blankSalesContractStatus} Contract is ready
            </AgxTypography>
          </>
        );
      } else if (
        campaign.blankSalesContractStatus === BlankSalesContractStatus.Final
      ) {
        return (
          <>
            <AgxIconCircularGreenTick width={44} height={45} />
            <AgxBodyText medium>
              You haven't created a contract yet!
            </AgxBodyText>
            <AgxBodyText medium>When you do, they'll appear here.</AgxBodyText>
          </>
        );
      }
    }
  }, []);

  return (
    <AgxSpacer
      padding={{ top: 'spacing-xl', bottom: 'spacing-xl' }}
      gap="spacing-xl"
      contentAlignment="center"
    >
      {bodyContent}
    </AgxSpacer>
  );
};
